import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import IssuedChequeEditView from 'src/sections/issued-cheque/view/issued-cheque-edit-view';

export default function IssuedChequeEditPage() {
  const { user: authUser } = useAuthContext();

  const { id } = useParams();

  return (
    <>
      <Helmet>
        <title> Edit Issued Cheque</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.UPDATE_ISSUED_CHEQUE,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <IssuedChequeEditView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
